/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileMpeg = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586v3.44h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M21.604 12.965c.165 0 .329.014.49.043.166.029.32.072.465.13v.712a3.307 3.307 0 0 0-.492-.119 2.508 2.508 0 0 0-.431-.038c-.413 0-.731.11-.954.33-.22.215-.33.527-.33.933 0 .453.095.793.286 1.02.194.222.489.333.884.334.151 0 .3-.009.443-.027l.054-.009v-.758l-.664-.22v-.453h1.452v1.926a3.14 3.14 0 0 1-.405.15c-.14.04-.286.069-.437.087a3.368 3.368 0 0 1-.464.032c-.662 0-1.163-.176-1.505-.528-.338-.353-.507-.87-.507-1.554 0-.42.083-.78.248-1.074.17-.299.41-.525.723-.68.316-.158.698-.237 1.143-.237zm-11.45 2.659 1.229-2.583h.88v3.922h-.831v-2.541l-1.037 2.163h-.517l-1.036-2.129v2.507h-.815V13.04h.88zm4.276-2.583c.482 0 .845.111 1.09.334.248.223.373.554.373.993 0 .291-.057.536-.168.734a1.036 1.036 0 0 1-.49.442c-.216.1-.485.151-.805.151h-.567v1.268h-.836V13.04zm-.567 1.969h.395c.287 0 .49-.049.61-.146.121-.1.183-.266.183-.496 0-.234-.061-.4-.184-.497-.118-.097-.322-.145-.61-.145h-.394zm5.099-1.257h-1.71v.874h1.554v.712h-1.554v.912h1.764v.712H16.41V13.04h2.552z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileMpeg as FileMpeg };
